import React from "react"

import ChatIcon from "../../assets/icons/chat.svg"
import Button from "../button"
import CustomCarousel from "../carousel"
import { spacesOptions } from "../../utils/constants"

const tabColors = {
  "Meeting Room": "bg-purple-200",
  "Flexday Suite": "bg-red-200",
  "Private Office": "bg-blue-200",
}

const InventoryCard = ({ location, selectedTab, selected, onSelected }) => {
  const handleInquire = (event) => {
    event.stopPropagation()
    let url = new URL(`${process.env.REACT_APP_FLEXDAY_URL}/book-workspace`)
    url.searchParams.append("selectedlocation", location.address)
    url.searchParams.append("selectedSpace", spacesOptions[selectedTab])
    window.location.href = url.href
  }

  return (
    <div
      className={`w-full flex flex-col justify-start items-center border-2 ${
        selected ? "border-primary" : "border-gray-400"
      }  rounded-xl cursor-pointer`}
      onClick={() => onSelected(location.id)}
      id={location.id}>
      <CustomCarousel images={location.images} selectedTab={selectedTab} />
      <div className="flex flex-col items-start justify-start w-full gap-1 sm:gap-2 px-3 py-2 sm:py-6">
        <div className={`w-fit ${tabColors[selectedTab]} px-2 py-1 rounded-md`}>
          <p className="text-base font-medium">{selectedTab}</p>
        </div>
        <p className="h-12 text-base font-medium line-clamp-2">
          {location.name}
        </p>
        <p className="h-12 text-base font-normal line-clamp-2">
          {location.address}
        </p>
        <Button
          title="Inquire"
          icon={ChatIcon}
          className="mt-0 sm:mt-4"
          onClick={handleInquire}
        />
      </div>
    </div>
  )
}

export default InventoryCard
